/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod';
import { costCalculatorAuthenticatedPostRequestSchema } from './costCalculatorAuthenticatedPostRequestSchema.ts';
import { costCalculatorAuthenticatedPostResponseSchema } from './costCalculatorAuthenticatedPostResponseSchema.ts';

/**
 * @description 200 response
 */
export const postCostCalculatorAuthenticated200Schema = z.lazy(() => costCalculatorAuthenticatedPostResponseSchema);

/**
 * @description 505 response
 */
export const postCostCalculatorAuthenticated505Schema = z.any();

export const postCostCalculatorAuthenticatedMutationRequestSchema = z.lazy(
  () => costCalculatorAuthenticatedPostRequestSchema
);

export const postCostCalculatorAuthenticatedMutationResponseSchema = z.lazy(
  () => postCostCalculatorAuthenticated200Schema
);
